import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Outlet, Navigate, useNavigate, useParams, useLocation, Link } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import logo from 'src/assets/images/logo.png';
import { Breadcrumb, Layout, Menu, Dropdown, Space, Avatar } from 'antd';
import UserAvatar from './UserAvatar';
import CustomSider from './CustomSider';
import { capitalize } from 'lodash';
import settingSelectors from 'src/redux/selectors/settingSelectors';
import './index.css';

const { Header, Content, Sider, Footer } = Layout;

const Dashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const themeColor = useSelector(settingSelectors.themeColor);
  const currentRoute = params['*'];
  const breadcrumbItems = location.pathname.split('/');
  breadcrumbItems.shift();

  useEffect(() => {
    currentRoute === '' && navigate("/dashboard/comics", { replace: true });
  }, [currentRoute]);

  return (
    <div style={{ display: 'flex', flex: 1 }}>
      <Layout>
        <Header style={{ display: 'flex', alignItems: 'center', height: 60, padding: 10, paddingLeft: 20, paddingRight: 20, lineHeight: 'normal', backgroundColor: themeColor }}>
          <img src={logo} alt="app logo" style={{ height: '100%', cursor: 'pointer' }} />
          <span style={{ color: 'white', fontSize: 18, fontWeight: 'bold', marginLeft: 20 }}>Infinity Comic</span>
          <div style={{ display: 'flex', flex: 1 }} />
          <UserAvatar />
        </Header>
        <Layout>
          <CustomSider />
          <Layout style={{ padding: 10 }} >
            <Breadcrumb>
              {breadcrumbItems.map(item => {
                const linkPath = location.pathname.split(item)[0];
                return <Breadcrumb.Item key={item} onClick={() => navigate(linkPath + item)}>{capitalize(item)}</Breadcrumb.Item>
              })}
            </Breadcrumb>
            <Content>
              <Outlet />
            </Content>
          </Layout>
        </Layout>
      </Layout>
    </div>
  )
}

export default Dashboard;